<template>
  <b-card class="cardStyle h-100">
    <p class="m-0 title">
      <b-icon icon="grid3x3-gap-fill" scale="1.3"></b-icon>&nbsp; &nbsp; {{ title }}
    </p>
    <div v-if="loading" id="loading" class="text-center my-5 py-5">
      <b-spinner class="align-middle" label="Spinning" type="grow"></b-spinner>
    </div>
    <div v-if="!loading">
      <b-progress :max="max" class="mb-2 mt-4" height="2rem" show-progress>
        <div v-if="value === 0" class="progressBarInfo" style="font-size:14px">
          <strong> 0/ {{ max }}</strong>
        </div>
        <b-progress-bar :style="progressColor" :value="value">
          <div v-if="requests.length > 0" style="font-size:14px">
            <strong> {{ value }}/ {{ max }}</strong>
          </div>
          <div v-if="requests.length === 0" style="font-size:12px">
            <strong class="text-dark">
              No Access Request have been submitted yet.
            </strong>
          </div>
        </b-progress-bar>
      </b-progress>
      <section class="text-center mt-3">
        <p class="textStyle mb-1" style="color: #6F6F6F;">
          {{ message }}
        </p>
        <hr class="solid my-4" style="width: 70%;" />
        <p class="textStyle mt-3" style="color: #383838;">
          For information about what system access is required for site activation, please refer to
          your Site Activation Checklist
        </p>
        <section v-if="!isSummaryPage">
          <div v-if="canRedirectToApplicationAccess">
            <b-button
              pill
              variant="outline-primary"
              @click="redirectToApplicationAccess('view-study-access-requests')"
              >View Submitted Requests</b-button
            >
          </div>
          <div v-if="canRedirectToApplicationAccess">
            <b-button
              class="mt-2"
              pill
              variant="outline-primary"
              @click="redirectToApplicationAccess('my-access')"
              >Manage Study Access</b-button
            >
          </div>
        </section>
      </section>
      <section
        v-if="isSummaryPage && !loading"
        class="text-right"
        style="position: absolute;bottom: 10px;width: 90%;"
      >
        <b-button
          class="mt-2"
          pill
          variant="link"
          @click="redirectToApplicationAccess('view-study-access-requests')"
          >Application Access</b-button
        >
      </section>
    </div>
  </b-card>
</template>

<script>
  export default {
    props: {
      siteId: String,
      studyId: String,
      canRedirectToApplicationAccess: Boolean,
      isSummaryPage: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        loading: false,
        requests: [],
        max: 1,
        value: 1,
      };
    },
    computed: {
      isEnrollmentOversight() {
        return this.$route.name.includes('oversight');
      },
      progressColor() {
        return this.requests.length > 0
          ? 'background: linear-gradient(270deg, #0000C9 0%, rgba(64, 64, 215, 0.54) 100%);opacity:0.6; '
          : 'background:#e9ecef';
      },
      title() {
        return this.isSummaryPage ? 'Site Team Application Access' : 'Application Access';
      },
      message() {
        if (this.canRedirectToApplicationAccess) {
          return 'This represents the total completed access requests out of all access requests submitted for the site team. Click on Application Access link below to identify the status and any pending actions.';
        }
        return 'This represents the total completed access requests out of all access requests submitted for the site team.';
      },
    },
    created() {
      this.getMyAccessRequestTickets();
    },
    methods: {
      redirectToApplicationAccess(option) {
        this.$router.push({
          name: this.isEnrollmentOversight ? 'oversight-application-access' : 'application-access',
          query: {
            option: option,
          },
        });
      },
      async getMyAccessRequestTickets() {
        this.tickets = [];
        try {
          this.loading = true;
          let response = await axios.get(`/api/get-access-requests`, {
            params: {
              study_id: this.studyId,
              site_number: this.siteId,
            },
          });
          if (response.status !== 204) {
            this.requests = response.data['items'];
            if (this.requests.length > 0) {
              this.value = 0;
              this.max = this.requests.length;
              this.requests.forEach(el => {
                if (['COMPLETED', 'CLOSED'].includes(el['parentstatus'])) {
                  this.value++;
                }
              });
            }
          }
        } catch (error) {
          console.error(error);
        }
        this.loading = false;
      },
    },
  };
</script>

<style scoped>
  .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.25px;
    color: #0060aa;
  }
  .textStyle {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    letter-spacing: 0.5px;
  }
  .progressBarInfo {
    padding-top: 1rem;
    padding-right: 0.5rem;
    text-align: right;
    width: 100%;
  }
</style>
